import { render, staticRenderFns } from "./MonitoringReportOtm.vue?vue&type=template&id=37a38d37&scoped=true&"
import script from "./MonitoringReportOtm.vue?vue&type=script&lang=js&"
export * from "./MonitoringReportOtm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a38d37",
  null
  
)

export default component.exports